module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "error-messages": _vm.validationMessageField(_vm.$v.dadosMatricula.pessoa.nome),
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.dadosMatricula.pessoa.nome.$touch()
      },
      "blur": function($event) {
        return _vm.$v.dadosMatricula.pessoa.nome.$touch()
      }
    },
    model: {
      value: (_vm.dadosMatricula.pessoa.nome),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.pessoa, "nome", $$v)
      },
      expression: "dadosMatricula.pessoa.nome"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "CPF",
      "mask": "###.###.###-##",
      "error-messages": _vm.validationMessageField(_vm.$v.dadosMatricula.pessoa_fisica.cpf),
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.dadosMatricula.pessoa_fisica.cpf.$touch()
      },
      "blur": function($event) {
        return _vm.$v.dadosMatricula.pessoa_fisica.cpf.$touch()
      }
    },
    model: {
      value: (_vm.dadosMatricula.pessoa_fisica.cpf),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.pessoa_fisica, "cpf", $$v)
      },
      expression: "dadosMatricula.pessoa_fisica.cpf"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "RG",
      "error-messages": _vm.validationMessageField(_vm.$v.dadosMatricula.pessoa_fisica.rg_numero),
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.dadosMatricula.pessoa_fisica.rg_numero.$touch()
      },
      "blur": function($event) {
        return _vm.$v.dadosMatricula.pessoa_fisica.rg_numero.$touch()
      }
    },
    model: {
      value: (_vm.dadosMatricula.pessoa_fisica.rg_numero),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.pessoa_fisica, "rg_numero", $$v)
      },
      expression: "dadosMatricula.pessoa_fisica.rg_numero"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm3": "",
      "xs12": ""
    }
  }, [_c('v-menu', {
    ref: "datepickerDtNascimento",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.mostrarDatepickerDtNascimento),
      callback: function($$v) {
        _vm.mostrarDatepickerDtNascimento = $$v
      },
      expression: "mostrarDatepickerDtNascimento"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    attrs: {
      "slot": "activator",
      "label": "Data de Nascimento",
      "prepend-icon": "event"
    },
    on: {
      "blur": function($event) {
        return _vm.$v.dadosMatricula.pessoa_fisica.dt_nascimento.$touch()
      }
    },
    slot: "activator",
    model: {
      value: (_vm.dt_nascimento_formatada),
      callback: function($$v) {
        _vm.dt_nascimento_formatada = $$v
      },
      expression: "dt_nascimento_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "error-messages": _vm.validationMessageField(_vm.$v.dadosMatricula.pessoa_fisica.dt_nascimento),
      "no-title": true,
      "locale": "pt-br"
    },
    on: {
      "input": function($event) {
        return _vm.$v.dadosMatricula.pessoa_fisica.dt_nascimento.$touch()
      },
      "blur": function($event) {
        return _vm.$v.dadosMatricula.pessoa_fisica.dt_nascimento.$touch()
      }
    },
    model: {
      value: (_vm.dadosMatricula.pessoa_fisica.dt_nascimento),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.pessoa_fisica, "dt_nascimento", $$v)
      },
      expression: "dadosMatricula.pessoa_fisica.dt_nascimento"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm5": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail Principal",
      "error-messages": _vm.validationMessageField(_vm.$v.dadosMatricula.pessoa.email, ['required', 'email']),
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.dadosMatricula.pessoa.email.$touch()
      },
      "blur": function($event) {
        return _vm.$v.dadosMatricula.pessoa.email.$touch()
      }
    },
    model: {
      value: (_vm.dadosMatricula.pessoa.email),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.pessoa, "email", $$v)
      },
      expression: "dadosMatricula.pessoa.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.validationMessageField(_vm.$v.dadosMatricula.pessoa_fisica.fone_celular),
      "mask": "(##) #####-####",
      "label": "Telefone Celular"
    },
    on: {
      "input": function($event) {
        return _vm.$v.dadosMatricula.pessoa_fisica.fone_celular.$touch()
      },
      "blur": function($event) {
        return _vm.$v.dadosMatricula.pessoa_fisica.fone_celular.$touch()
      }
    },
    model: {
      value: (_vm.dadosMatricula.pessoa_fisica.fone_celular),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.pessoa_fisica, "fone_celular", $$v)
      },
      expression: "dadosMatricula.pessoa_fisica.fone_celular"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm3": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.validationMessageField(_vm.$v.dadosMatricula.pessoa.cep),
      "mask": "#####-###",
      "label": "CEP",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.dadosMatricula.pessoa.cep.$touch()
      },
      "blur": function($event) {
        return _vm.$v.dadosMatricula.pessoa.cep.$touch()
      }
    },
    model: {
      value: (_vm.dadosMatricula.pessoa.cep),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.pessoa, "cep", $$v)
      },
      expression: "dadosMatricula.pessoa.cep"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm5": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.validationMessageField(_vm.$v.dadosMatricula.pessoa.rua),
      "label": "Rua",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.dadosMatricula.pessoa.rua.$touch()
      },
      "blur": function($event) {
        return _vm.$v.dadosMatricula.pessoa.rua.$touch()
      }
    },
    model: {
      value: (_vm.dadosMatricula.pessoa.rua),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.pessoa, "rua", $$v)
      },
      expression: "dadosMatricula.pessoa.rua"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.validationMessageField(_vm.$v.dadosMatricula.pessoa.numero),
      "label": "Número",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.dadosMatricula.pessoa.numero.$touch()
      },
      "blur": function($event) {
        return _vm.$v.dadosMatricula.pessoa.numero.$touch()
      }
    },
    model: {
      value: (_vm.dadosMatricula.pessoa.numero),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.pessoa, "numero", $$v)
      },
      expression: "dadosMatricula.pessoa.numero"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.validationMessageField(_vm.$v.dadosMatricula.pessoa.bairro),
      "label": "Bairro",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.dadosMatricula.pessoa.bairro.$touch()
      },
      "blur": function($event) {
        return _vm.$v.dadosMatricula.pessoa.bairro.$touch()
      }
    },
    model: {
      value: (_vm.dadosMatricula.pessoa.bairro),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.pessoa, "bairro", $$v)
      },
      expression: "dadosMatricula.pessoa.bairro"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Complemento"
    },
    model: {
      value: (_vm.dadosMatricula.pessoa.complemento),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.pessoa, "complemento", $$v)
      },
      expression: "dadosMatricula.pessoa.complemento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "error-messages": _vm.validationMessageField(_vm.$v.dadosMatricula.pessoa.ref_cidade),
      "items": _vm.dependencias.cidades,
      "loading": _vm.buscandoCidades,
      "search-input": _vm.buscarCidade,
      "browser-autocomplete": "matriculaonlineautocompletecidade",
      "item-value": "id",
      "label": "Cidade",
      "placeholder": "Digite o nome da cidade",
      "no-data-text": "Nenhuma registro encontrado",
      "hide-no-data": "",
      "hide-selected": "",
      "no-filter": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.dadosMatricula.pessoa.ref_cidade.$touch()
      },
      "blur": function($event) {
        return _vm.$v.dadosMatricula.pessoa.ref_cidade.$touch()
      },
      "update:searchInput": function($event) {
        _vm.buscarCidade = $event
      },
      "update:search-input": function($event) {
        _vm.buscarCidade = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_vm._v("\n                    " + _vm._s(data.item.nome) + " / " + _vm._s(data.item.ref_estado) + "\n                ")]
      }
    }, {
      key: "selection",
      fn: function(data) {
        return [_vm._v("\n                    " + _vm._s(data.item.nome) + " / " + _vm._s(data.item.ref_estado) + "\n                ")]
      }
    }]),
    model: {
      value: (_vm.dadosMatricula.pessoa.ref_cidade),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.pessoa, "ref_cidade", $$v)
      },
      expression: "dadosMatricula.pessoa.ref_cidade"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-header"
  }, [_c('navigation-buttons', {
    attrs: {
      "show-previous": false,
      "show-next": true,
      "next-click": _vm.salvarDados,
      "disable-next": _vm.$v.dadosMatricula.$invalid
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c19eca4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/matricula_online/DadosPessoais.vue
// module id = 549
// module chunks = 2